module.exports = __webpack_public_path__ + "img/plus-active-icon.294f97a4.svg";